// extracted by mini-css-extract-plugin
export var cardLayout = "_8h-1";
export var paginationContainer = "_8h-0";